import React from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  Container,
  Icon,
} from '@chakra-ui/react';
import { Flag } from '@phosphor-icons/react';

const DmcaPage = () => {
  return (
    <Container maxW="container.md" py={10}>
      <VStack spacing={8} align="stretch">
        <Box>
          <Heading>DMCA Takedown Request</Heading>
          <Text mt={4}>
            To submit a DMCA Takedown request, please find the image on our site, open it in the preview modal, and click the <Icon as={Flag} /> icon.
          </Text>
          <Text mt={2}>
            From there, you can select "DMCA Takedown Request" and fill out the required information. This ensures that we can identify the exact image you are referring to and process your request promptly.
          </Text>
        </Box>
      </VStack>
    </Container>
  );
};

export default DmcaPage;
